import { render, staticRenderFns } from "./businessOrder.vue?vue&type=template&id=2dcaa154&scoped=true&"
import script from "./businessOrder.vue?vue&type=script&lang=js&"
export * from "./businessOrder.vue?vue&type=script&lang=js&"
import style0 from "./businessOrder.vue?vue&type=style&index=0&id=2dcaa154&scoped=scoped&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dcaa154",
  null
  
)

export default component.exports